import { MatchedGiving as PageMatchedGiving } from '@web/components/page-components/DonationForm'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'

type MatchedGivingProps = {}

const MatchedGiving = (props: MatchedGivingProps) => {
  const activeMatchedGiving = usePageStore((state) => state.activeMatchedGiving)

  return (
    activeMatchedGiving && (
      <PageMatchedGiving multiplier={activeMatchedGiving.rounds[activeMatchedGiving.activeRound].multiplier} />
    )
  )
}

export default MatchedGiving
